import type { CallOrder } from '@/store/orders/call/state.ts';

export const isCallOrder = (order: unknown): order is CallOrder => {
  return order !== null && typeof order === 'object' && (order as CallOrder).type === 'CallOrder';
};
